<template lang="pug">
  section.introduce
    article.osIntroduceText
      hgroup
        h1(:class="titleAnimation") HAMIS OS
        h2
          span.blue H
          | ighly&nbsp
          span.blue A
          | utomatic&nbsp
          span.blue M
          | achine&nbsp
          span.blue I
          | ntelligence&nbsp
          span.blue S
          | ystem
      p 高度自动化的人工智能云计算系统，面向行业+云计算+AI，为企业提供端到端系统级智能的解决方案，降低垂直行业应用门槛和难度。助力企业迈入数字经济时代，实现降本增效，获得新时代红利。
      div
        span.text “AI PaaS, 由2018年的萌芽期开始进入2019的蓬勃发展期。”
        img(:src="Gartner")
      router-link(:to="{name: 'GuestForm'}" @click="gotoExperience") 了解更多
    .advantages
      .advantage(v-for="(item, index) in advantages" v-show="contentIsShow"
        :class="[contentAnimation, `animateDelay-${index}`]")
        img(:src="item.img")
        div
          span {{ item.title }}
          span {{ item.text }}
</template>

<script>
  import Gartner from '@/assets/images/gartnerlogo.png';
  import intelligence from '@/assets/images/协同智能化icon.png';
  import integration from '@/assets/images/云边端一体化icon.png';
  import deployment from '@/assets/images/一键部署icon.png';
  import cost from '@/assets/images/110成本icon.png';
  import AI from '@/assets/images/5分钟用AIicon.png';
  import iot from '@/assets/images/AI+IoT闭环icon.png';
  
  import Mixin from '../../index';
  
  export default {
    name: "introduce",
    mixins: [Mixin],
    data() {
      return {
        Gartner,
        advantages: [
          {img: intelligence, title: '协同智能化', text: '赋能企业顶级AI能力'},
          {img: integration, title: '云边端一体化', text: '一体化的智能解决方案'},
          {img: deployment, title: '一键部署', text: '一键自动化脚本部署'},
          {img: cost, title: '1/10成本', text: '降本增效，缩减90%成本'},
          {img: AI, title: '五分钟上手AI', text: '轻松使用云、AI、区块链技术'},
          {img: iot, title: 'AI+IoT闭环', text: '云边协同，让体系更智能'},
        ],
        showAnimate: 'animated fadeInLeft',
        contentAnimate: 'animated fadeInRight',
      };
    },
    methods: {
      gotoExperience() {
        // this.$router.push({name: 'GuestForm'});
        window.scrollTo(0, 0);
      },
    }
  };
</script>

<style scoped lang="stylus">
  @import "../../index.styl"
  .introduce {
    padding 100px 0 0
    display flex
    justify-content center
    align-items flex-start
  
    .osIntroduceText {
      flex-shrink 0
      width 550px
      display flex
      flex-direction column
      align-items flex-start
      justify-content flex-start
      .blue {
        FontSetting(Montserrat)
        color #269bff
        font-weight 400
      }
      & > span, & > div, & > button, h1, h2, h3 {
        margin 0
        margin-top 15px
      }
      h1, h2, h3 {
        &::after {
          content none
        }
      }
    
      h1 {
        font-size 48px
        color #202020
        margin-top 0
        FontSetting(Montserrat)
        font-weight bold
      }
    
      h2 {
        font-size 18px
        color #626262
        margin-top 6px
        FontSetting(Montserrat)
        font-weight 300
      }
    
      & > p {
        max-width 100%
        font-size 18px
        color #202020
        line-height 30px
        FontSetting("思源黑体 CN Regular")
      }
    
      & > div {
        font-size 18px
        background-color #f8f8f8
        width 100%
        padding 20px
        display flex
        flex-direction column
        box-sizing border-box
        margin-top 60px
      
        .text {
          font-size 18px
          color #202020
          FontSetting("思源黑体 CN Regular")
        }
      
        & > img {
          margin-left auto
          margin-top 20px
          width 90px
        }
      }
    
      & > a {
        border 0
        margin-top 24px
        background-color transparent
        color #269bff
        font-size 14px
        FontSetting("思源黑体 CN Regular")
      
        &::after {
          content "→"
          margin-left 10px
          padding-bottom 2px
        }
      }
    }
  
    .advantages {
      display flex
      align-items center
      justify-content center
      flex-wrap wrap
      margin-top -60px
      width 820px
    
      .advantage {
        display flex
        align-items center
        justify-content flex-start
        flex-direction column
        margin 0 28px
        margin-top 60px
        > div {
          VStack(center)
          span:first-of-type {
            font-size 20px
            color #202020
            font-weight bold
            FontSetting("思源黑体 CN Bold")
          }
  
          span:last-of-type {
            margin-top 16px
            font-size 16px
            color #626262
            FontSetting("思源黑体 CN Regular")
          }
        }
      }
    }
  }
  @media (max-width: ipadProScreenWidth) {
    .introduce {
      VStack(center)
      .advantages {
        margin-top 0
      }
    }
  }
  @media (max-width 800px) {
    .introduce {
      .advantages {
        max-width 100%
        width 100%
        .advantage {
          img {
            width 100%
          }
        }
      }
    }
  }
  @media (max-width 580px) {
    .introduce {
      .osIntroduceText {
        width 100vw
        padding 20px
        box-sizing border-box
        h1 {
          font-size 24px
        }
        h2 {
          font-size 16px
        }
        p {
          font-size 14px
        }
        > div {
          margin-top 0
          .text {
            font-size 16px
          }
        }
      }
    }
  }
  @media (max-width screenWidth) {
    .introduce {
      width 100vw
      padding 50px 0 0
      VStack()
      .osIntroduceText {
        width 100vw
        padding 20px
        box-sizing border-box
      }
      .advantages {
        width 100vw
        margin-top 0
        .advantage {
          margin 0
          width 50%
          box-sizing border-box
          > img {
            width 180px
          }
          > div {
            span:first-of-type {
              font-size 16px
            }
            span:last-of-type {
              font-size 14px
            }
          }
        }
      }
    }
  }
</style>
